import { baseApi } from '@ibk/shared-config';
export const benefitsNetworkApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAcceptedLocations: builder.query({
            query: ({ partnerId, ...params }) => ({
                url: `/v1/voucher/partners/${partnerId}/accepted-locations`,
                params: {
                    limit: params.limit,
                    offset: params.offset,
                    latitude: params.latitude,
                    longitude: params.longitude,
                    product: params.product,
                    radius: params.radius,
                    ...(params.companyName && { companyName: params.companyName }),
                },
            }),
            providesTags: ['Base'],
            keepUnusedDataFor: 0,
        }),
    }),
});
export const { useGetAcceptedLocationsQuery } = benefitsNetworkApi;
